/* Serial Seal — CUSTOM GRADING TAG renderer (window.GT).
 *
 * A grading tag is a NEW USE of the existing seal die: the same 0.75" x 1.77"
 * (44.958 x 19.05 mm) holographic vinyl, the same press, the same imposition.
 * Nothing here may change the physical label — W/H below ARE the die and are
 * shared with ss-seal.js by value.
 *
 * SELF-CONTAINED ON PURPOSE. This file renders in three places with three
 * different sets of neighbours: the tag builder (ss-render.js present), the
 * cart page (maybe present), and Label Farm's production sidecar (nothing else
 * present). So it carries its own esc/fit/foil defs and only borrows
 * SS.inkSafe when it happens to exist. Preview and print use THIS one code
 * path at different scales — that is what keeps cart artwork honest.
 *
 * HOUSE MATERIAL RULES (same as ss-seal.js):
 *   · there is no white ink. '#ffffff' is a BARE-FOIL declaration — the
 *     brightest thing this product can produce is unprinted stock.
 *   · pale ink vanishes into the foil, so every ground colour here is deep,
 *     and translucent tints (fill-opacity) are how "colour" reads on holo.
 *
 * LEGAL SHAPE. These are the customer's own collector display tags. The
 * layouts are original Serial Seal furniture (the cut-corner panel language
 * from ss-seal.js) — no PSA/BGS/CGC/SGC/TAG label geometry, fonts or colour
 * systems, and nothing here prints a grading company's name unless the
 * customer types it as their own text, which is theirs to do. */
(function () {
  'use strict';

  var W = 44.958, H = 19.05;          /* the die — NEVER change these */
  var M = 1.2;                        /* safe margin inside the cut */
  var INK = '#04050a';                /* same ink as ss-seal.js */
  var _n = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function inkSafe(c) {
    if (window.SS && window.SS.inkSafe) { try { return window.SS.inkSafe(c); } catch (_) {} }
    return /^#[0-9a-fA-F]{6}$/.test(String(c || '')) ? c : INK;
  }

  /* cut-corner rect — the ss-seal panel language, which is OUR furniture */
  function cutRect(x, y, w, h, c) {
    return 'M' + r2(x + c) + ' ' + r2(y) + 'H' + r2(x + w - c) +
      'L' + r2(x + w) + ' ' + r2(y + c) + 'V' + r2(y + h - c) +
      'L' + r2(x + w - c) + ' ' + r2(y + h) + 'H' + r2(x + c) +
      'L' + r2(x) + ' ' + r2(y + h - c) + 'V' + r2(y + c) + 'Z';
  }
  function roundRect(x, y, w, h, r) {
    return 'M' + r2(x + r) + ' ' + r2(y) + 'H' + r2(x + w - r) +
      'Q' + r2(x + w) + ' ' + r2(y) + ' ' + r2(x + w) + ' ' + r2(y + r) +
      'V' + r2(y + h - r) + 'Q' + r2(x + w) + ' ' + r2(y + h) + ' ' + r2(x + w - r) + ' ' + r2(y + h) +
      'H' + r2(x + r) + 'Q' + r2(x) + ' ' + r2(y + h) + ' ' + r2(x) + ' ' + r2(y + h - r) +
      'V' + r2(y + r) + 'Q' + r2(x) + ' ' + r2(y) + ' ' + r2(x + r) + ' ' + r2(y) + 'Z';
  }
  /* Halo colour for text, set per-render in svg(). ALWAYS the opposite
     polarity to the glyph: on a dark plate the text is bare foil (#ffffff)
     and so is the guilloche, so white-on-white vanished (owner 2026-08-22:
     "the white [guilloche] thing is cooking the text, i can't read it").
     A ring of ground ink under the glyphs separates the two foil areas. */
  var _HALO = null;

  function txt(x, y, size, fill, s, opts) {
    opts = opts || {};
    if (!s) return '';
    var halo = (opts.halo === false || !_HALO || fill === _HALO) ? '' :
      ' paint-order="stroke fill" stroke="' + _HALO + '" stroke-width="' +
      r2(Math.max(0.10, size * 0.15)) + '" stroke-linejoin="round"';
    return '<text x="' + r2(x) + '" y="' + r2(y) + '" font-family="Helvetica, Arial, sans-serif"' +
      halo +
      ' font-size="' + r2(size) + '"' +
      (opts.w === false ? '' : ' font-weight="bold"') +
      (opts.anchor ? ' text-anchor="' + opts.anchor + '"' : '') +
      (opts.ls ? ' letter-spacing="' + opts.ls + '"' : '') +
      (opts.op ? ' opacity="' + opts.op + '"' : '') +
      (opts.fit ? ' data-fit="' + r2(opts.fit) + '"' : '') +
      ' fill="' + fill + '">' + esc(s) + '</text>';
  }

  /* ── BACKGROUND STYLES ────────────────────────────────────────────────
     ground: what floods the plate. dark: does TEXT knock out to foil
     ('#ffffff') or print as ink. Every colour is holo-safe by construction. */
  var BGS = [
    { key: 'holo',      name: 'Open Holo', dark: false },
    { key: 'black',     name: 'Black',     dark: true },
    { key: 'silver',    name: 'Silver',    dark: false },
    { key: 'gold',      name: 'Gold',      dark: true, tint: '#6b4a00' },
    { key: 'red',       name: 'Red',       dark: true, tint: '#6e0f1e' },
    { key: 'blue',      name: 'Blue',      dark: true, tint: '#123a6e' },
    { key: 'purple',    name: 'Purple',    dark: true, tint: '#40196b' },
    { key: 'green',     name: 'Green',     dark: true, tint: '#0e4f2c' },
    { key: 'prismatic', name: 'Prismatic', dark: false },
    { key: 'premium',   name: 'Premium',   dark: true }
  ];
  var LAYOUTS = [
    { key: 'classic',  name: 'Classic' },
    { key: 'price',    name: 'Price Tag' },
    { key: 'modern',   name: 'Modern' },
    { key: 'subgrade', name: 'Subgrade' },
    { key: 'minimal',  name: 'Minimal' },
    { key: 'branded',  name: 'Branded' },
    { key: 'wave',     name: 'Holo Wave' },
    { key: 'apex',     name: 'Apex' },
    { key: 'stub',     name: 'Sidebar' },
    { key: 'slash',    name: 'Slash' },
    { key: 'arc',      name: 'Arc' },
    { key: 'ticket',   name: 'Ticket' },
    { key: 'plate',    name: 'Plate' }
  ];
  function bgOf(k)  { for (var i = 0; i < BGS.length; i++) if (BGS[i].key === k) return BGS[i]; return BGS[0]; }
  function layOf(k) { for (var i = 0; i < LAYOUTS.length; i++) if (LAYOUTS[i].key === k) return LAYOUTS[i]; return LAYOUTS[0]; }

  function norm(c) {
    c = c || {};
    var sub = c.sub || null;
    if (sub && !(sub.c || sub.cr || sub.e || sub.su)) sub = null;
    return {
      layout: layOf(c.layout).key, bg: bgOf(c.bg).key,
      name: String(c.name || '').trim(),
      year: String(c.year || '').trim(),
      set: String(c.set || '').trim(),
      number: String(c.number || '').trim(),
      extra: String(c.extra || '').trim(),
      grade: String(c.grade || '').trim(),
      gl: String(c.gl || '').trim(),
      tid: String(c.tid || '').trim(),
      sub: sub,
      brand: String(c.brand || '').trim(),
      logo: String(c.logo || '').trim(),
      accent: inkSafe(c.accent || '#7c4dff')
    };
  }

  /* the line under the name: "Base Set • 4/102 • 1st Edition", parts optional */
  function metaLine(c) {
    var parts = [];
    if (c.set) parts.push(c.set);
    if (c.number) parts.push(c.number);
    if (c.extra) parts.push(c.extra);
    return parts.join(' • ');
  }

  function svg(cfg) {
    var c = norm(cfg);
    var bg = bgOf(c.bg);
    var id = 'gt' + (++_n);
    var dark = bg.dark;
    /* PRICE TAG (owner 2026-10-10): the right half is BLANK STOCK for a price
       written in Sharpie. Everything the style draws - the ground, the
       rosette, the type - is clipped to the left half, so not one dot of ink
       lands on the write-in side; only the die keyline and a divider frame it. */
    var half = c.layout === 'price';
    var TXT = dark ? '#ffffff' : INK;       /* #ffffff = bare foil, never white ink */
    /* opposite polarity to the glyph fill, so type always separates from the
       security guilloche and any busy ground underneath it */
    _HALO = dark ? INK : '#ffffff';
    var MUT = dark ? '#ffffff' : INK;       /* same pigment, thinner via opacity */
    var o = [];
    o.push('<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" data-gt="1">');

    /* ── defs: local foil-patch + premium gradient (self-contained) ── */
    o.push('<defs>');
    o.push('<linearGradient id="' + id + 'f" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#ffffff"/><stop offset="0.5" stop-color="#ffffff" stop-opacity="0.92"/>' +
      '<stop offset="1" stop-color="#ffffff"/></linearGradient>');
    o.push('<linearGradient id="' + id + 'p" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#101830"/><stop offset="0.55" stop-color="#04050a"/>' +
      '<stop offset="1" stop-color="#241335"/></linearGradient>');
    /* clip to the FULL die, not 0.5mm inside it — otherwise it re-imposes the
       very margin the full-bleed flood removes (owner 2026-08-22) */
    o.push('<clipPath id="' + id + 'c"><path d="' + roundRect(0, 0, W, H, 1.6) + '"/></clipPath>');
    if (half) o.push('<clipPath id="' + id + 'h"><rect x="0" y="0" width="' + PRICE_X +
      '" height="' + H + '"/></clipPath>');
    o.push('</defs>');

    /* ── plate ── */
    o.push('<g clip-path="url(#' + id + 'c)">');
    if (half) o.push('<g clip-path="url(#' + id + 'h)">');
    /* FULL BLEED (owner 2026-08-22: "the tag isn't using the full paper").
       This used to stop 1.0mm short of the cut on every side so the border
       came out as bare iridescent foil — the mock's "holographic frame". The
       owner wants the ground edge to edge instead, so the plate now floods
       the whole die and the clip path (0.5in, r1.35) rounds it to the die
       shape. To restore the foil ring, put back roundRect(1.0, 1.0, W-2, H-2,
       1.2). The keyline below still draws the border at the old inset. */
    function flood(fill, extra) {
      o.push('<path d="' + roundRect(0, 0, W, H, 1.6) + '" fill="' + fill + '"' +
        (extra || '') + '/>');
    }
    if (c.bg === 'black') {
      flood(INK);
    } else if (c.bg === 'premium') {
      flood('url(#' + id + 'p)');
    } else if (bg.tint) {
      flood(bg.tint, ' fill-opacity="0.86"');
    } else if (c.bg === 'silver') {
      o.push('<rect width="' + W + '" height="' + H + '" fill="' + INK + '" fill-opacity="0.16"/>');
    } else if (c.bg === 'prismatic') {
      /* faceted burst: ink wedges radiating from beyond the corner, bare
         foil flashing between them — the refractor look built from the
         material itself, not hairline noise */
      var fx = -4, fy = H + 6, FR = 64;
      var seg = [[-82, -74, 0.10], [-71, -62, 0.05], [-58, -52, 0.12], [-49, -40, 0.06],
                 [-37, -31, 0.10], [-28, -20, 0.05], [-16, -9, 0.11], [-6, -1, 0.06]];
      for (var pi = 0; pi < seg.length; pi++) {
        var a1 = seg[pi][0] * Math.PI / 180, a2 = seg[pi][1] * Math.PI / 180;
        o.push('<path d="M' + r2(fx) + ' ' + r2(fy) +
          'L' + r2(fx + FR * Math.cos(a1)) + ' ' + r2(fy + FR * Math.sin(a1)) +
          'L' + r2(fx + FR * Math.cos(a2)) + ' ' + r2(fy + FR * Math.sin(a2)) +
          'Z" fill="' + INK + '" opacity="' + seg[pi][2] + '"/>');
      }
    }
    /* 'holo' floods nothing: the foil IS the ground */

    /* the security decal rides UNDER every layout */
    if (half) guilloche(o, PRICE_X * 0.36, H / 2, 4.0, dark, INK);
    else guilloche(o, W * 0.40, H / 2, 5.2, dark, INK);

    /* ── layout ── */
    var MOCK = { apex: drawApex, stub: drawStub, slash: drawSlash,
                 arc: drawArc, ticket: drawTicket, plate: drawPlate, price: drawPrice };
    if (MOCK[c.layout]) {
      /* full-plate compositions guided by the owner's reference boards —
         each owns its brand, grade, data and serial zones */
      MOCK[c.layout](o, c, id, dark);
    } else {
    var hasSub = !!(c.sub && (c.layout === 'subgrade' || c.layout === 'classic'));
    var ownBrand = (c.layout === 'modern' || c.layout === 'branded');
    var hasRow = !!((c.brand || c.logo) && !ownBrand);
    var gp = gradePanel(c, id, dark, hasSub, hasRow);
    var left = M + 1.0, right = gp.x - 1.2;
    var dy = hasRow ? 3.1 : 0;
    if (hasRow) drawBrandRow(o, c, id, TXT, dark, left, right);
    if (c.layout === 'classic')  drawClassic(o, c, TXT, MUT, left, right, dark, dy, hasSub);
    if (c.layout === 'modern')   drawModern(o, c, id, TXT, MUT, left, right, dark);
    if (c.layout === 'subgrade') drawSubgrade(o, c, TXT, MUT, left, right, dy);
    if (c.layout === 'minimal')  drawMinimal(o, c, TXT, MUT, left, right, dy);
    if (c.layout === 'branded')  drawBranded(o, c, id, TXT, MUT, left, right, dark);
    if (c.layout === 'wave')     drawWave(o, c, TXT, MUT, left, right, dark, dy);
    if (hasSub) drawSubStrip(o, c, dark);
    /* the number footer — a finished edge, not an afterthought: hairline with
       end ticks, tracked mono-ish figure */
    if (c.tid && !hasSub && (c.layout === 'classic' || c.layout === 'subgrade')) {
      var fc = dark ? '#ffffff' : INK, fy = H - M - 2.3;
      line(o, left, fy, right, fy, fc, 0.4);
      line(o, left, fy - 0.5, left, fy + 0.5, fc, 0.4);
      line(o, right, fy - 0.5, right, fy + 0.5, fc, 0.4);
      o.push(txt(left, H - M - 0.7, 1.25, TXT, c.tid.toUpperCase(),
        { ls: 0.24, fit: right - left - 14, op: 0.85 }));
      micro(o, right, H - M - 0.75, 'CUSTOM DISPLAY TAG', TXT, { anchor: 'end', op: 0.4 });
    }
    o.push(gp.svg);
    }

    if (half) {
      o.push('</g>');
      /* the divider: the write-in side's left wall, the keyline's weight */
      line(o, PRICE_X, 1.0, PRICE_X, H - 1.0, INK, 0.75, 0.18);
    }
    o.push('</g>');
    if (half && dark) {
      /* on a dark ground the keyline below is bare foil, which is invisible on
         the bare write-in side - frame that side in ink instead */
      o.push('<clipPath id="' + id + 'r"><rect x="' + PRICE_X + '" y="0" width="' +
        r2(W - PRICE_X) + '" height="' + H + '"/></clipPath>');
      o.push('<path clip-path="url(#' + id + 'r)" d="' + roundRect(1.0, 1.0, W - 2, H - 2, 1.2) +
        '" fill="none" stroke="' + INK + '" stroke-width="0.18" opacity="0.75"/>');
    }
    /* one confident keyline against the cut — the whole border system */
    o.push('<path d="' + roundRect(1.0, 1.0, W - 2, H - 2, 1.2) + '" fill="none" stroke="' +
      (dark ? '#ffffff' : INK) + '" stroke-width="0.18" opacity="' + (dark ? 0.55 : 0.75) + '"/>');
    o.push('</svg>');
    return o.join('');
  }


  /* ═══ COMPOSITION v2 helpers ═══════════════════════════════════════════ */
  var HAIR = 0.13;                     /* the one hairline weight */
  function line(o, x1, y1, x2, y2, col, op, w) {
    o.push('<path d="M' + r2(x1) + ' ' + r2(y1) + 'L' + r2(x2) + ' ' + r2(y2) +
      '" stroke="' + col + '" stroke-width="' + (w || HAIR) + '"' +
      (op ? ' opacity="' + op + '"' : '') + '/>');
  }
  /* the certificate voice: a tiny tracked label above a value */
  function micro(o, x, y, s, col, opts) {
    opts = opts || {};
    o.push(txt(x, y, 0.85, col, String(s).toUpperCase(),
      { ls: 0.2, op: opts.op || 0.55, anchor: opts.anchor, fit: opts.fit }));
  }

  /* ── the grade panel: LAYERED — outer hairline, inset fill, one huge
     number, the wording in its own band. The single loudest element. ── */
  function gradePanel(c, id, dark, hasSub, hasRow) {
    var w = 10.6, x = W - M - w - 0.3;
    var y = M + 0.6 + (hasRow ? 3.3 : 0);
    var h = (hasSub ? H - 2 * M - 5.6 : H - 2 * M - 1.2) - (hasRow ? 3.3 : 0);
    if (!c.grade) return { x: x, svg: '' };
    var o = [];
    var edge = dark ? 'url(#' + id + 'f)' : c.accent;
    o.push('<path d="' + cutRect(x, y, w, h, 1.0) + '" fill="none" stroke="' + edge +
      '" stroke-width="0.2"/>');
    o.push('<path d="' + cutRect(x + 0.45, y + 0.45, w - 0.9, h - 0.9, 0.72) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var gTxt = '#ffffff';
    var isNum = /^[0-9]+(\.[0-9])?$/.test(c.grade);
    var cx = x + w / 2;
    if (h < 9.5) {
      /* the brand row AND the strip both took their bite — number only */
      o.push(txt(cx, y + h / 2 + 1.7, 4.6, gTxt,
        isNum ? c.grade : c.grade.toUpperCase(), { anchor: 'middle', fit: w - 1.8 }));
      return { x: x, svg: o.join('') };
    }
    if (isNum && c.gl) {
      /* the slab order: wording ABOVE the number — GEM MINT over 9.5 reads
         at arm's length exactly the way collectors expect */
      o.push(txt(cx, y + 2.5, 1.35, gTxt, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.14, fit: w - 1.4, op: 0.95 }));
      o.push(txt(cx, y + 2.9 + (h - 3.4) / 2 + 2.6, 7.0, gTxt, c.grade,
        { anchor: 'middle', fit: w - 1.6 }));
    } else if (isNum) {
      o.push(txt(cx, y + (h + 5.4) / 2, 7.4, gTxt, c.grade,
        { anchor: 'middle', fit: w - 1.6 }));
    } else {
      o.push(txt(cx, y + h / 2 + 1.2, 2.5, gTxt, c.grade.toUpperCase(),
        { anchor: 'middle', fit: w - 1.4 }));
    }
    return { x: x, svg: o.join('') };
  }

  /* ── the brand row: small mark + tracked name over a finished rule ── */
  function drawBrandRow(o, c, id, TXT, dark, left, right) {
    var x = left;
    if (c.logo) {
      o.push(logoBox(c, id, left, M + 0.55, 2.7, 2.7, dark));
      x = left + 3.6;
    }
    if (c.brand) {
      o.push(txt(x, M + 2.5, 1.6, TXT, c.brand.toUpperCase(),
        { ls: 0.34, fit: right - x }));
    }
    line(o, left, M + 3.7, right, M + 3.7, dark ? '#ffffff' : INK, 0.45);
  }

  /* ── CLASSIC: the slab reading order — YEAR + SET small on top, the NAME
     as the loudest line, then #NUMBER • variety. The order every collector
     already reads, with no field-label furniture in the way. ── */
  function drawClassic(o, c, TXT, MUT, left, right, dark, dy, hasSub) {
    var y0 = M + (dy ? dy + 0.6 : 1.6);
    var topline = [c.year, c.set].filter(Boolean).join('  ').toUpperCase();
    if (topline) {
      o.push(txt(left, y0 + 1.5, 1.5, MUT, topline, { ls: 0.12, op: 0.82, fit: right - left }));
      y0 += 2.3;
    }
    var nameSize = hasSub ? 2.7 : 3.2;
    o.push(txt(left, y0 + nameSize, nameSize, TXT,
      (c.name || 'CARD NAME').toUpperCase(), { fit: right - left, ls: 0.05 }));
    var no = c.number ? (c.number.charAt(0) === '#' ? c.number : '#' + c.number) : '';
    var sub = [no, c.extra].filter(Boolean).join(' • ');
    if (sub) o.push(txt(left, y0 + nameSize + 2.2, 1.6, TXT, sub,
      { op: 0.9, fit: right - left }));
  }

  /* ── MODERN: an accent spine, logo + brand top, name mid, facts low ── */
  function drawModern(o, c, id, TXT, MUT, left, right, dark) {
    var spine = dark ? 'url(#' + id + 'f)' : c.accent;
    o.push('<rect x="' + r2(left - 0.2) + '" y="' + r2(M + 0.7) + '" width="0.7" height="' +
      r2(H - 2 * M - 1.4) + '" rx="0.3" fill="' + spine + '"/>');
    var x = left + 1.9;
    if (c.logo) {
      o.push(logoBox(c, id, x, M + 0.9, 3.0, 3.0, dark));
      if (c.brand) o.push(txt(x + 3.8, M + 2.85, 1.5, TXT, c.brand.toUpperCase(),
        { ls: 0.28, fit: right - x - 3.8, op: 0.9 }));
    } else if (c.brand) {
      o.push(txt(x, M + 2.85, 1.5, TXT, c.brand.toUpperCase(),
        { ls: 0.28, fit: right - x, op: 0.9 }));
    }
    o.push(txt(x, M + 8.3, 3.2, TXT, (c.name || 'CARD NAME').toUpperCase(),
      { fit: right - x, ls: 0.05 }));
    var ml = metaLine(c);
    if (ml) o.push(txt(x, M + 11.0, 1.5, MUT, ml, { w: false, op: 0.85, fit: right - x }));
    if (c.year) micro(o, x, H - M - 0.9, c.year, MUT, { op: 0.5, fit: right - x });
  }

  /* ── SUBGRADE: compact head over the data bar ── */
  function drawSubgrade(o, c, TXT, MUT, left, right, dy) {
    var y0 = M + (dy ? dy + 0.7 : 1.4);
    o.push(txt(left, y0 + 2.8, 2.8, TXT, (c.name || 'CARD NAME').toUpperCase(),
      { fit: right - left, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(left, y0 + 4.9, 1.5, MUT, ml, { w: false, op: 0.85, fit: right - left }));
  }

  /* ── the data bar: ONE bar, internal dividers, micro labels ── */
  function drawSubStrip(o, c, dark) {
    var fc = dark ? '#ffffff' : INK;
    var bx = M + 0.45, bw = W - 2 * M - 0.9, by = H - M - 4.2, bh = 4.0;
    o.push('<path d="' + cutRect(bx, by, bw, bh, 0.55) + '" fill="' + fc +
      '" fill-opacity="' + (dark ? 0.1 : 0.05) + '" stroke="' + fc +
      '" stroke-width="0.14" stroke-opacity="0.55"/>');
    var labels = [['CENTERING', 'c'], ['CORNERS', 'cr'], ['EDGES', 'e'], ['SURFACE', 'su']];
    var cw = bw / 4;
    for (var i = 0; i < 4; i++) {
      var cx0 = bx + i * cw;
      if (i) line(o, cx0, by + 0.55, cx0, by + bh - 0.55, fc, 0.3);
      micro(o, cx0 + cw / 2, by + 1.3, labels[i][0], fc, { anchor: 'middle', op: 0.6 });
      o.push(txt(cx0 + cw / 2, by + 3.45, 2.2, fc,
        (c.sub && c.sub[labels[i][1]]) || '–', { anchor: 'middle' }));
    }
  }

  /* ── MINIMAL: the name, the grade, silence ── */
  function drawMinimal(o, c, TXT, MUT, left, right, dy) {
    var cx = (left + right) / 2, y0 = dy || 0;
    o.push(txt(cx, M + 7.2 + y0 * 0.55, 3.9, TXT, (c.name || 'CARD NAME').toUpperCase(),
      { anchor: 'middle', fit: right - left, ls: 0.06 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(cx, M + 10.4 + y0 * 0.55, 1.55, MUT, ml,
      { w: false, anchor: 'middle', fit: right - left, op: 0.85 }));
  }

  /* ── BRANDED: the mark is the point — big logo, accent band, then card ── */
  function drawBranded(o, c, id, TXT, MUT, left, right, dark) {
    var x = left;
    if (c.logo) {
      o.push(logoBox(c, id, left, M + 0.9, 4.4, 4.4, dark));
      x = left + 5.5;
    }
    if (c.brand) {
      o.push(txt(x, M + 3.4, 2.0, TXT, c.brand.toUpperCase(),
        { ls: 0.3, fit: right - x }));
    }
    o.push('<rect x="' + r2(left) + '" y="' + r2(M + 5.9) + '" width="' +
      r2(right - left) + '" height="0.45" rx="0.22" fill="' +
      (dark ? '#ffffff' : c.accent) + '"' + (dark ? ' opacity="0.85"' : '') + '/>');
    o.push(txt(left, M + 9.8, 2.9, TXT, (c.name || 'CARD NAME').toUpperCase(),
      { fit: right - left, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(left, M + 12.2, 1.5, MUT, ml, { w: false, op: 0.85, fit: right - left }));
  }

  /* ── HOLO WAVE: three layered arcs of light through the lower third ── */
  function drawWave(o, c, TXT, MUT, left, right, dark, dy) {
    var y0 = dy || 0;
    dy = y0;
    var wv = dark ? '#ffffff' : c.accent;
    var mx = (left + right) / 2;
    var ay = (dy || 0) * 0.45;      /* the brand row pushes the text down — the
                                        arcs give way by the same breath */
    o.push('<path d="M' + r2(left - 3) + ' ' + r2(14.4 + ay) + ' Q ' + r2(mx) + ' ' +
      r2(9.2 + ay) + ' ' + r2(right + 3) + ' ' + r2(13.2 + ay) +
      '" fill="none" stroke="' + wv + '" stroke-width="0.5" opacity="0.9"/>');
    o.push('<path d="M' + r2(left - 3) + ' ' + r2(15.6 + ay) + ' Q ' + r2(mx) + ' ' +
      r2(10.8 + ay) + ' ' + r2(right + 3) + ' ' + r2(14.6 + ay) +
      '" fill="none" stroke="' + wv + '" stroke-width="0.26" opacity="0.5"/>');
    o.push('<path d="M' + r2(left - 3) + ' ' + r2(16.7 + ay) + ' Q ' + r2(mx) + ' ' +
      r2(12.4 + ay) + ' ' + r2(right + 3) + ' ' + r2(15.9 + ay) +
      '" fill="none" stroke="' + wv + '" stroke-width="0.13" opacity="0.28"/>');
    /* no year chip when the brand row owns the top; and the meta line rides
       tight under the name so the arcs never strike it */
    if (c.year && !y0) micro(o, right, M + 1.9, c.year, MUT, { anchor: 'end', op: 0.5, fit: 9 });
    var nb = M + 5.6 + y0;
    o.push(txt(left, nb, 3.2, TXT, (c.name || 'CARD NAME').toUpperCase(),
      { fit: right - left, ls: 0.05 }));
    var ml = metaLine(c);
    if (y0 && c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(left, nb + 1.85, 1.5, MUT, ml, { w: false, op: 0.85, fit: right - left }));
  }

  /* ═══ MOTIF KIT — the reference boards' ornament language ════════════ */
  function spark(x, y, r, col, op) {
    var q = r * 0.24;
    return '<path d="M' + r2(x) + ' ' + r2(y - r) +
      'Q' + r2(x + q) + ' ' + r2(y - q) + ' ' + r2(x + r) + ' ' + r2(y) +
      'Q' + r2(x + q) + ' ' + r2(y + q) + ' ' + r2(x) + ' ' + r2(y + r) +
      'Q' + r2(x - q) + ' ' + r2(y + q) + ' ' + r2(x - r) + ' ' + r2(y) +
      'Q' + r2(x - q) + ' ' + r2(y - q) + ' ' + r2(x) + ' ' + r2(y - r) +
      'Z" fill="' + col + '"' + (op ? ' opacity="' + op + '"' : '') + '/>';
  }
  function ticks2(o, x, y, col) {           /* the // serial mark */
    for (var i = 0; i < 2; i++)
      line(o, x + i * 0.72, y + 0.55, x + i * 0.72 + 0.5, y - 0.55, col, 0.8, 0.2);
  }
  function perf(o, x, y1, y2, col) {        /* ticket perforation dots */
    for (var y = y1; y <= y2; y += 0.95)
      o.push('<circle cx="' + r2(x) + '" cy="' + r2(y) + '" r="0.2" fill="' + col +
        '" opacity="0.5"/>');
  }
  function barcode(o, x, y, w, h, col, seed, acc, dark) {
    /* deterministic bars from the design's own serial/name — cache-stable */
    var sd = String(seed || 'SERIALSEAL'), bx = x, i = 0;
    while (bx < x + w - 0.4) {
      var code = sd.charCodeAt(i % sd.length) + i * 7;
      var bw = 0.16 + (code % 4) * 0.1;
      if (i === 11 && acc) {
        /* one accent bar: knock out first on dark, then wash */
        if (dark) o.push('<rect x="' + r2(bx) + '" y="' + r2(y) + '" width="' + r2(bw) +
          '" height="' + r2(h) + '" fill="#ffffff"/>');
        o.push('<rect x="' + r2(bx) + '" y="' + r2(y) + '" width="' + r2(bw) +
          '" height="' + r2(h) + '" fill="' + acc + '"' + (dark ? ' fill-opacity="0.55"' : '') + '/>');
      } else {
        o.push('<rect x="' + r2(bx) + '" y="' + r2(y) + '" width="' + r2(bw) +
          '" height="' + r2(h) + '" fill="' + col + '" opacity="' + ((code % 3) ? 0.85 : 0.5) + '"/>');
      }
      bx += bw + 0.2 + (code % 3) * 0.07; i++;
    }
  }
  /* ── SECURITY DECAL: banknote-style guilloche rosette. On dark plates
     the lines are FULL-STRENGTH bare foil ('#ffffff') but hairline-thin —
     the holographic stock shines through a fine interference pattern that
     is easy to recognise and hard to replicate, without fighting the
     label. Foil grounds get the same rosette as ink hairlines (the ground
     itself already shines). ── */
  function guilloche(o, cx, cy, R, dark, ink) {
    var col = dark ? '#ffffff' : ink;
    /* data-gtdecal lets the preview soften this group to the weight the
       press actually produces — browsers floor hairlines at ~1px and
       overstate it several-fold on screen */
    var e = ['<g data-gtdecal="1"' + (dark ? '' : ' opacity="0.35"') + '>'];
    for (var k = 0; k < 12; k++) {
      e.push('<ellipse cx="' + r2(cx) + '" cy="' + r2(cy) + '" rx="' + r2(R) +
        '" ry="' + r2(R * 0.38) + '" transform="rotate(' + (k * 15) + ' ' +
        r2(cx) + ' ' + r2(cy) + ')" fill="none" stroke="' + col +
        '" stroke-width="0.08"/>');
    }
    e.push('<circle cx="' + r2(cx) + '" cy="' + r2(cy) + '" r="' + r2(R * 1.04) +
      '" fill="none" stroke="' + col + '" stroke-width="0.08"/>');
    e.push('<circle cx="' + r2(cx) + '" cy="' + r2(cy) + '" r="' + r2(R * 0.62) +
      '" fill="none" stroke="' + col + '" stroke-width="0.08"/>');
    e.push('<circle cx="' + r2(cx) + '" cy="' + r2(cy) + '" r="' + r2(R * 0.24) +
      '" fill="none" stroke="' + col + '" stroke-width="0.08"/>');
    e.push('</g>');
    o.push(e.join(''));
  }

  function holoZone(o, d, dark, acc, op) {
    /* a patch of tinted bare foil: on dark grounds knock the flood out
       (white = no ink laid), then wash with the accent */
    if (dark) o.push('<path d="' + d + '" fill="#ffffff"/>');
    o.push('<path d="' + d + '" fill="' + acc + '" fill-opacity="' +
      (op || (dark ? 0.42 : 0.25)) + '"/>');
  }
  function holoStroke(o, d, dark, acc, w, op) {
    if (dark) o.push('<path d="' + d + '" fill="none" stroke="#ffffff" stroke-width="' + w + '"/>');
    o.push('<path d="' + d + '" fill="none" stroke="' + acc + '" stroke-width="' + w +
      '" opacity="' + (op || 0.55) + '"/>');
  }
  /* labeled data cells: YEAR / SET / NO. — the boards' footer data zone.
     SET gets the wide column so long set names keep a readable size. */
  function dataCells(o, c, x, w, y, h, fc, slant) {
    var cols = [];
    if (c.year) cols.push(['YEAR', c.year]);
    if (c.set) cols.push(['SET', c.set]);
    if (c.number) cols.push(['NO.', c.number]);
    if (!cols.length) return;
    var fr = cols.length === 3 ? [0.24, 0.46, 0.30] : cols.length === 2 ? [0.5, 0.5] : [1];
    var cx = x;
    for (var i = 0; i < cols.length; i++) {
      var cw = w * fr[i];
      if (i) {
        if (slant) line(o, cx + 0.55, y + 0.35, cx - 0.55, y + h - 0.35, fc, 0.5, 0.16);
        else line(o, cx, y + 0.45, cx, y + h - 0.45, fc, 0.4, 0.14);
      }
      micro(o, cx + cw / 2, y + 1.3, cols[i][0], fc, { anchor: 'middle', op: 0.6 });
      o.push(txt(cx + cw / 2, y + h - 0.75, 1.75, fc, cols[i][1],
        { anchor: 'middle', fit: cw - (slant ? 1.5 : 1.1) }));
      cx += cw;
    }
  }

  /* ═══ MOCK-GUIDED LAYOUTS (six boards, same die) ═════════════════════ */

  /* APEX — board 1: brand row + trailing rule, big name, holo facet low-left,
     slanted data cells, tall angular grade column, serial with // ticks */
  function drawApex(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK, gTxt = '#ffffff';
    var px = W - M - 9.6, pw = 9.6, py = M + 0.5, ph = H - 2 * M - 4.4;
    var x0 = M + 1.0, bx = x0;
    if (c.logo) { o.push(logoBox(c, id, x0, M + 0.65, 2.6, 2.6, dark)); bx = x0 + 3.7; }
    if (c.brand) o.push(txt(bx, M + 2.35, 1.55, fc, c.brand.toUpperCase(),
      { ls: 0.34, fit: px - 9.6 - bx }));
    if (c.brand || c.logo) {
      /* the rule springs from the brand, never from mid-air */
      var rx = c.brand ? Math.min(bx + c.brand.length * 1.3 + 1.2, px - 8.2) : bx;
      line(o, rx, M + 1.95, px - 1.2, M + 1.95, fc, 0.6, 0.18);
    }
    o.push(txt(x0, M + 7.4, 3.4, fc, (c.name || 'CARD NAME').toUpperCase(),
      { fit: px - 1.6 - x0, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(x0, M + 9.9, 1.5, fc, ml, { w: false, op: 0.85, fit: px - 1.6 - x0 }));
    holoZone(o, 'M1 ' + r2(H - 6.6) + 'L' + r2(x0 + 7.2) + ' ' + r2(H - 4.7) +
      'L1 ' + r2(H - 4.7) + 'Z', dark, c.accent, dark ? 0.42 : 0.5);
    line(o, 1.0, H - 6.6, x0 + 7.2, H - 4.7, fc, 0.7, 0.2);
    dataCells(o, c, x0 + 8.0, px - 9.4 - x0, H - M - 4.4, 4.0, fc, true);
    o.push('<path d="' + cutRect(px, py, pw, ph, 1.3) + '" fill="none" stroke="' + fc +
      '" stroke-width="0.22"/>');
    o.push('<path d="' + cutRect(px + 0.5, py + 0.5, pw - 1.0, ph - 1.0, 1.0) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var cx = px + pw / 2;
    micro(o, cx, py + 2.0, 'GRADE', gTxt, { anchor: 'middle', op: 0.75 });
    if (c.grade) o.push(txt(cx, py + ph / 2 + 2.6, 6.2, gTxt, c.grade,
      { anchor: 'middle', fit: pw - 2.2 }));
    if (c.gl) {
      line(o, px + 1.3, py + ph - 2.3, px + pw - 1.3, py + ph - 2.3, gTxt, 0.4);
      o.push(txt(cx, py + ph - 0.95, 1.1, gTxt, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.12, fit: pw - 1.8, op: 0.95 }));
    } else {
      line(o, px + 1.3, py + ph - 1.9, cx - 1.3, py + ph - 1.9, gTxt, 0.35);
      line(o, cx + 1.3, py + ph - 1.9, px + pw - 1.3, py + ph - 1.9, gTxt, 0.35);
      o.push(spark(cx, py + ph - 1.9, 0.6, gTxt, 0.9));
    }
    if (c.tid) {
      var sy = H - M - 1.15, sL = px - 1.0, sR = W - M + 0.2;
      var scx2 = (sL + sR) / 2;
      if (c.tid.length <= 8) {
        ticks2(o, sL + 0.2, sy - 0.45, fc);
        ticks2(o, sR - 1.55, sy - 0.45, fc);
        o.push(txt(scx2, sy, 1.2, fc, c.tid.toUpperCase(),
          { anchor: 'middle', ls: 0.16, fit: sR - sL - 4.2, op: 0.9 }));
      } else {
        o.push(txt(scx2, sy, 1.2, fc, c.tid.toUpperCase(),
          { anchor: 'middle', ls: 0.16, fit: sR - sL - 0.6, op: 0.9 }));
      }
    }
  }

  /* PRICE TAG — the LEFT HALF of the die (0 .. PRICE_X) carries the card; the
     right half is left as bare stock to write a price on. A compact grade
     panel on the inner edge, the reading column beside it: brand row, year +
     set, the name (two lines when it is long), number + variety, cert number.
     Subgrades do not print here (the builder says so). */
  var PRICE_X = r2(W / 2);
  function drawPrice(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK, gTxt = '#ffffff';
    var pw = 7.4, px = r2(PRICE_X - 0.9 - pw), py = M + 0.5, ph = H - 2 * M - 1.0;
    var x0 = M + 0.9, right = px - 0.9, cw = right - x0;
    /* the grade panel: same layering as gradePanel, narrower */
    o.push('<path d="' + cutRect(px, py, pw, ph, 1.0) + '" fill="none" stroke="' +
      (dark ? 'url(#' + id + 'f)' : c.accent) + '" stroke-width="0.2"/>');
    o.push('<path d="' + cutRect(px + 0.45, py + 0.45, pw - 0.9, ph - 0.9, 0.72) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var gcx = px + pw / 2, isNum = /^[0-9]+(\.[0-9])?$/.test(c.grade);
    if (c.gl) o.push(txt(gcx, py + 2.4, 1.05, gTxt, c.gl.toUpperCase(),
      { anchor: 'middle', ls: 0.1, fit: pw - 1.4, op: 0.95 }));
    if (c.grade) {
      if (isNum) o.push(txt(gcx, py + ph / 2 + (c.gl ? 3.0 : 2.4), 6.4, gTxt, c.grade,
        { anchor: 'middle', fit: pw - 1.5 }));
      else o.push(txt(gcx, py + ph / 2 + 0.9, 2.1, gTxt, c.grade.toUpperCase(),
        { anchor: 'middle', fit: pw - 1.3 }));
    } else {
      micro(o, gcx, py + ph / 2 + 0.3, 'GRADE', gTxt, { anchor: 'middle', op: 0.6 });
    }
    /* the reading column, stacked from the top */
    var y = M + 0.5;
    if (c.brand || c.logo) {
      var bx = x0;
      if (c.logo) { o.push(logoBox(c, id, x0, y + 0.2, 2.2, 2.2, dark)); bx = x0 + 2.6; }
      if (c.brand) o.push(txt(bx, y + 1.85, 1.2, fc, c.brand.toUpperCase(),
        { fit: right - bx }));
      line(o, x0, y + 3.0, right, y + 3.0, fc, 0.45);
      y += 4.0;
    }
    var topline = [c.year, c.set].filter(Boolean).join(' ').toUpperCase();
    if (topline) {
      o.push(txt(x0, y + 1.25, 1.2, fc, topline, { op: 0.85, fit: cw }));
      y += 2.0;
    }
    var nm = (c.name || 'CARD NAME').toUpperCase(), lines = [nm];
    if (nm.length > 11 && nm.indexOf(' ') > 0) {
      var mid = nm.length / 2, best = -1;
      for (var i = 0; i < nm.length; i++) {
        if (nm.charAt(i) === ' ' && (best < 0 || Math.abs(i - mid) < Math.abs(best - mid))) best = i;
      }
      lines = [nm.slice(0, best), nm.slice(best + 1)];
    }
    var ns = lines.length > 1 ? 2.05 : 2.4;
    for (var li = 0; li < lines.length; li++) {
      o.push(txt(x0, y + ns + li * ns * 1.12, ns, fc, lines[li], { fit: cw, ls: 0.04 }));
    }
    y += ns + (lines.length - 1) * ns * 1.12 + 0.4;
    var no = c.number ? (c.number.charAt(0) === '#' ? c.number : '#' + c.number) : '';
    var sub = [no, c.extra].filter(Boolean).join(' • ');
    if (sub) o.push(txt(x0, y + 1.5, 1.3, fc, sub, { op: 0.9, fit: cw }));
    if (c.tid) o.push(txt(x0, H - M - 0.55, 1.0, fc, c.tid.toUpperCase(),
      { ls: 0.18, op: 0.85, fit: cw }));
  }

  /* SIDEBAR — board 2: left rail with mark + vertical brand, rule-led main
     zone, footer data bar whose serial cell wears a holo corner */
  function drawStub(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK, gTxt = '#ffffff';
    var railR = 6.4, x0 = railR + 1.2;
    var px = W - M - 10.2, pw = 10.2, py = M + 0.5, ph = 11.2;
    o.push('<path d="M1 1H' + r2(railR) + 'V' + r2(H - 1) + 'H1Z" fill="' + fc +
      '" fill-opacity="' + (dark ? 0.07 : 0.05) + '"/>');
    line(o, railR, 1.2, railR, H - 1.2, fc, 0.7, 0.2);
    if (c.logo) o.push(logoBox(c, id, 1.9, 2.0, 3.5, 3.5, dark));
    if (c.brand) {
      o.push('<text x="0" y="0" font-family="Helvetica, Arial, sans-serif" font-size="1.3"' +
        ' font-weight="bold" text-anchor="middle" letter-spacing="0.42" fill="' + fc +
        '" data-fit="' + r2(c.logo ? 10.9 : 15.4) + '" transform="translate(' +
        r2((railR + 1) / 2 + 0.5) + ' ' + r2(c.logo ? 11.85 : H / 2 + 0.4) +
        ') rotate(-90)">' + esc(c.brand.toUpperCase()) + '</text>');
    }
    if (c.brand) o.push(txt(x0, M + 1.95, 1.3, fc, c.brand.toUpperCase(),
      { ls: 0.32, op: 0.75, fit: px - 1.2 - x0 }));
    o.push(txt(x0, M + 5.9, 3.3, fc, (c.name || 'CARD NAME').toUpperCase(),
      { fit: px - 1.2 - x0, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(x0, M + 8.3, 1.5, fc, ml, { w: false, op: 0.85, fit: px - 1.2 - x0 }));
    line(o, x0, M + 10.1, px - 1.2, M + 10.1, fc, 0.75, 0.28);
    var fy = H - M - 4.3, sw = c.tid ? 11.6 : 0;
    line(o, x0, fy, W - M - 0.4, fy, fc, 0.5, 0.16);
    dataCells(o, c, x0, W - M - 0.4 - x0 - sw, fy, 4.0, fc, false);
    if (c.tid) {
      var sx = W - M - 0.4 - sw;
      line(o, sx, fy + 0.5, sx, fy + 3.6, fc, 0.4, 0.14);
      holoZone(o, 'M' + r2(W - M - 3.4) + ' ' + r2(fy + 4.0) + 'L' + r2(W - M - 0.4) + ' ' +
        r2(fy + 1.4) + 'L' + r2(W - M - 0.4) + ' ' + r2(fy + 4.0) + 'Z', dark, c.accent,
        dark ? 0.5 : 0.3);
      o.push(txt(sx + (sw - 1.2) / 2, fy + 2.75, 1.35, fc, c.tid.toUpperCase(),
        { anchor: 'middle', ls: 0.14, fit: sw - 2.6 }));
    }
    o.push('<path d="' + cutRect(px, py, pw, ph, 2.0) + '" fill="none" stroke="' + fc +
      '" stroke-width="0.24"/>');
    o.push('<path d="' + cutRect(px + 0.55, py + 0.55, pw - 1.1, ph - 1.1, 1.6) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var cx = px + pw / 2;
    micro(o, cx, py + 2.15, 'GRADE', gTxt, { anchor: 'middle', op: 0.75 });
    if (c.grade && c.gl) {
      o.push(txt(cx, py + ph - 3.3, 5.2, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.6 }));
      o.push(txt(cx, py + ph - 1.35, 1.05, gTxt, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.12, fit: pw - 2.0, op: 0.95 }));
    } else if (c.grade) {
      o.push(txt(cx, py + ph - 2.0, 5.8, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.6 }));
    }
  }

  /* SLASH — board 3: diagonal foil slash, tinted-foil grade wedge right,
     knockout number, slanted data cells across the footer */
  function drawSlash(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK;
    var fy = H - M - 4.3, d1 = 25.2, d2 = 31.8, x0 = M + 1.0;
    holoZone(o, 'M' + r2(d1) + ' 1L' + r2(W - 1) + ' 1V' + r2(fy) + 'H' + r2(d2) + 'Z',
      dark, c.accent, dark ? 0.42 : 0.26);
    line(o, d1 + 0.2, 1.0, d2 + 0.2, fy, fc, 1, 0.65);
    line(o, d1 - 1.3, 1.0, d2 - 1.3, fy, fc, 0.55, 0.18);
    if (c.brand) {
      o.push(txt(x0, M + 2.1, 1.4, fc, c.brand.toUpperCase(), { ls: 0.34, fit: d1 - 3.4 - x0 }));
      line(o, x0, M + 3.2, d1 - 3.8, M + 3.2, fc, 0.55, 0.16);
    }
    o.push(txt(x0, M + 7.6, 3.5, fc, (c.name || 'CARD NAME').toUpperCase(),
      { fit: d1 - 2.4 - x0, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(x0, M + 10.2, 1.5, fc, ml, { w: false, op: 0.85, fit: d1 - 1.2 - x0 }));
    /* grade lives in the wedge, all INK — the tinted foil is the light
       thing, so the number is dark and cannot wash out. The board's stack:
       GRADE, number, wording, serial. */
    var cx = (d2 + W - 1) / 2 + 1.2, low = !!(c.gl || c.tid);
    micro(o, cx, M + 2.1, 'GRADE', INK, { anchor: 'middle', op: 0.75 });
    if (c.grade) o.push(txt(cx, M + (low ? 8.8 : 9.6), low ? 5.9 : 6.8, INK, c.grade,
      { anchor: 'middle', fit: 8.6 }));
    if (c.gl) o.push(txt(cx, M + 10.8, 1.15, INK, c.gl.toUpperCase(),
      { anchor: 'middle', ls: 0.12, fit: 9.4, op: 0.9 }));
    if (c.tid) o.push(txt(cx, M + (c.gl ? 12.15 : 10.8), 1.05, INK, c.tid.toUpperCase(),
      { anchor: 'middle', ls: 0.12, fit: 10.2, op: 0.8 }));
    line(o, M + 0.4, fy, W - M - 0.4, fy, fc, 0.5, 0.16);
    dataCells(o, c, M + 0.6, W - 2 * M - 1.2, fy, 4.0, fc, true);
  }

  /* ARC — board 4: centered brand plaque, layered foil + accent arcs,
     dashed grade panel, sparked serial cell */
  function drawArc(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK, gTxt = '#ffffff';
    var px = W - M - 9.8, pw = 9.8, py = M + 0.6, x0 = M + 1.0;
    var fy = H - M - 4.3, ph = fy - py - 0.6;
    var pcx = (M + px) / 2;
    if (c.brand) {
      var ew = Math.min(c.brand.length * 1.28 / 2 + 1.1, (px - x0) / 2 - 4.6);
      line(o, pcx - ew - 4.0, M + 1.4, pcx - ew, M + 1.4, fc, 0.6, 0.16);
      line(o, pcx + ew, M + 1.4, pcx + ew + 4.0, M + 1.4, fc, 0.6, 0.16);
      o.push(txt(pcx, M + 1.9, 1.5, fc, c.brand.toUpperCase(),
        { anchor: 'middle', ls: 0.35, fit: px - x0 - 8.4 }));
    }
    o.push(txt(x0, M + 6.7, 3.4, fc, (c.name || 'CARD NAME').toUpperCase(),
      { fit: px - 1.4 - x0, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(x0, M + 9.1, 1.5, fc, ml, { w: false, op: 0.85, fit: px - 1.4 - x0 }));
    o.push('<path d="M1 12.8Q14 9.9 ' + r2(px + 1.2) + ' 11.7" fill="none" stroke="' + fc +
      '" stroke-width="0.18" opacity="0.5"/>');
    o.push('<path d="M1 13.4Q14 10.5 ' + r2(px + 1.2) + ' 12.5" fill="none" stroke="' + fc +
      '" stroke-width="0.62" opacity="0.95"/>');
    holoStroke(o, 'M1 13.5Q14 11.4 ' + r2(px + 1.2) + ' 13.3', dark, c.accent, 0.4, 0.65);
    var sw = c.tid ? 11.4 : 0;
    line(o, M + 0.4, fy, W - M - 0.4, fy, fc, 0.5, 0.16);
    dataCells(o, c, M + 0.6, W - 2 * M - 1.2 - sw, fy, 4.0, fc, false);
    if (c.tid) {
      var sx = W - M - 0.6 - sw;
      line(o, sx, fy + 0.5, sx, fy + 3.6, fc, 0.4, 0.14);
      if (c.tid.length <= 10) {
        o.push(spark(sx + 1.6, fy + 2.3, 0.55, fc, 0.85));
        o.push(txt(sx + 2.6, fy + 2.75, 1.3, fc, c.tid.toUpperCase(),
          { ls: 0.14, fit: sw - 3.4, op: 0.95 }));
      } else {
        o.push(txt(sx + 1.0, fy + 2.75, 1.3, fc, c.tid.toUpperCase(),
          { ls: 0.14, fit: sw - 1.6, op: 0.95 }));
      }
    }
    o.push('<path d="' + cutRect(px, py, pw, ph, 1.3) + '" fill="none" stroke="' + fc +
      '" stroke-width="0.22"/>');
    o.push('<path d="' + cutRect(px + 0.5, py + 0.5, pw - 1.0, ph - 1.0, 1.0) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var cx = px + pw / 2;
    line(o, cx - 4.3, py + 1.7, cx - 2.7, py + 1.7, gTxt, 0.5, 0.13);
    line(o, cx + 2.7, py + 1.7, cx + 4.3, py + 1.7, gTxt, 0.5, 0.13);
    micro(o, cx, py + 2.05, 'GRADE', gTxt, { anchor: 'middle', op: 0.75 });
    if (c.grade && c.gl) {
      o.push(txt(cx, py + ph - 3.0, 5.6, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.4 }));
      o.push(txt(cx, py + ph - 1.05, 1.05, gTxt, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.12, fit: pw - 2.0, op: 0.95 }));
    } else if (c.grade) {
      o.push(txt(cx, py + ph / 2 + 2.7, 6.2, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.2 }));
    }
  }

  /* TICKET — board 5: ticket frame, perforated stub, brand between rules,
     centered card block, barcode + mark, MINT plaque on the stub */
  function drawTicket(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK;
    o.push('<path d="' + cutRect(1.7, 1.7, W - 3.4, H - 3.4, 1.4) + '" fill="none" stroke="' +
      fc + '" stroke-width="0.2" opacity="0.85"/>');
    var pfx = W - M - 11.0;
    perf(o, pfx, 2.9, H - 2.9, fc);
    var lcx = (1.7 + pfx) / 2;
    if (c.brand) {
      var ew = Math.min(c.brand.length * 1.22 / 2 + 1.0, (pfx - 1.7) / 2 - 4.4);
      line(o, lcx - ew - 3.4, 3.35, lcx - ew, 3.35, fc, 0.6, 0.16);
      line(o, lcx + ew, 3.35, lcx + ew + 3.4, 3.35, fc, 0.6, 0.16);
      o.push(txt(lcx, 3.85, 1.45, fc, c.brand.toUpperCase(),
        { anchor: 'middle', ls: 0.35, fit: pfx - 8.2 }));
    }
    o.push(txt(lcx, 7.3, 3.2, fc, (c.name || 'CARD NAME').toUpperCase(),
      { anchor: 'middle', fit: pfx - 5.4, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(lcx, 9.4, 1.45, fc, ml,
      { w: false, anchor: 'middle', op: 0.85, fit: pfx - 5.0 }));
    line(o, 3.9, 10.55, pfx - 2.2, 10.55, fc, 0.5, 0.15);
    dataCells(o, c, 3.9, pfx - 6.1, 10.9, 3.7, fc, false);
    if (c.logo) o.push(logoBox(c, id, 3.9, 15.0, 1.9, 1.9, dark));
    barcode(o, c.logo ? 6.6 : 4.4, 15.1, pfx - (c.logo ? 6.6 : 4.4) - 2.4, 1.7, fc,
      c.tid || c.name, c.accent, dark);
    var scx = (pfx + W - 1.7) / 2 + 0.5;
    line(o, scx - 4.1, 3.3, scx - 2.6, 3.3, fc, 0.5, 0.13);
    line(o, scx + 2.6, 3.3, scx + 4.1, 3.3, fc, 0.5, 0.13);
    micro(o, scx, 3.65, 'GRADE', fc, { anchor: 'middle', op: 0.75 });
    if (c.grade) o.push(txt(scx, 9.3, 5.4, fc, c.grade, { anchor: 'middle', fit: 8.2 }));
    if (c.gl) {
      o.push('<path d="' + cutRect(scx - 3.9, 10.5, 7.8, 2.5, 0.6) + '" fill="' + fc +
        '" fill-opacity="0.08" stroke="' + fc + '" stroke-width="0.16"/>');
      o.push(txt(scx, 12.2, 1.15, fc, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.14, fit: 6.6 }));
    }
    if (c.tid) o.push(txt(scx, H - 2.75, 1.05, fc, c.tid.toUpperCase(),
      { anchor: 'middle', ls: 0.12, fit: 9.0, op: 0.8 }));
  }

  /* PLATE — board 6: quiet keyline plate, brand + trailing rule, inline
     labeled columns, rounded grade square with the serial beneath */
  function drawPlate(o, c, id, dark) {
    var fc = dark ? '#ffffff' : INK, gTxt = '#ffffff';
    o.push('<path d="' + cutRect(2.1, 2.1, W - 4.2, H - 4.2, 1.5) + '" fill="none" stroke="' +
      fc + '" stroke-width="0.18" opacity="0.8"/>');
    var x0 = 3.9, pw = 10.4, px = W - 2.1 - pw - 1.0, py = 3.1, ph = 10.6;
    if (c.brand) {
      o.push(txt(x0, 4.55, 1.45, fc, c.brand.toUpperCase(), { ls: 0.34, fit: px - 9.2 - x0 }));
      line(o, px - 8.6, 4.05, px - 1.0, 4.05, fc, 0.6, 0.16);
    }
    o.push(txt(x0, 8.9, 3.6, fc, (c.name || 'CARD NAME').toUpperCase(),
      { fit: px - 1.2 - x0, ls: 0.05 }));
    var ml = metaLine(c);
    if (c.year) ml = ml ? c.year + ' • ' + ml : c.year;
    if (ml) o.push(txt(x0, 11.2, 1.5, fc, ml, { w: false, op: 0.85, fit: px - 1.2 - x0 }));
    dataCells(o, c, x0 - 0.6, px - 0.8 - x0, 12.4, 4.0, fc, false);
    o.push('<path d="' + roundRect(px, py, pw, ph, 1.6) + '" fill="none" stroke="' + fc +
      '" stroke-width="0.22"/>');
    o.push('<path d="' + roundRect(px + 0.5, py + 0.5, pw - 1.0, ph - 1.0, 1.2) +
      '" fill="' + INK + '"' + (dark ? ' fill-opacity="0.5"' : '') + '/>');
    var cx = px + pw / 2;
    micro(o, cx, py + 2.15, 'GRADE', gTxt, { anchor: 'middle', op: 0.75 });
    if (c.grade && c.gl) {
      o.push(txt(cx, py + ph - 3.1, 5.2, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.8 }));
      o.push(txt(cx, py + ph - 1.25, 1.05, gTxt, c.gl.toUpperCase(),
        { anchor: 'middle', ls: 0.12, fit: pw - 2.2, op: 0.95 }));
    } else if (c.grade) {
      o.push(txt(cx, py + ph - 2.2, 5.6, gTxt, c.grade, { anchor: 'middle', fit: pw - 2.8 }));
    }
    if (c.tid) o.push(txt(cx, py + ph + 1.8, 1.15, fc, c.tid.toUpperCase(),
      { anchor: 'middle', ls: 0.14, fit: pw + 0.6, op: 0.9 }));
  }

  /* the logo slot: contain-fit image on a quiet backing so any mark reads on
     any ground. dark ground -> soft foil patch; foil ground -> nothing. */
  function logoBox(c, id, x, y, w, h, dark) {
    var o = [];
    if (dark) {
      o.push('<path d="' + cutRect(x - 0.3, y - 0.3, w + 0.6, h + 0.6, 0.6) +
        '" fill="url(#' + id + 'f)" stroke="' + INK + '" stroke-width="0.12" stroke-opacity="0.5"/>');
    }
    o.push('<image href="' + esc(c.logo) + '" x="' + r2(x) + '" y="' + r2(y) +
      '" width="' + r2(w) + '" height="' + r2(h) + '" preserveAspectRatio="xMidYMid meet"/>');
    return o.join('');
  }

  /* ── fit pass: shrink any text[data-fit] wider than its cap ──────────
     Runs after the SVG is in the DOM (getComputedTextLength needs layout).
     Returns the smallest final size, so a caller can refuse a layout that
     went unreadable instead of silently printing 0.6mm type. */
  function fit(root) {
    var floor = 99;
    var ts = root.querySelectorAll('text[data-fit]');
    for (var i = 0; i < ts.length; i++) {
      var el = ts[i], max = parseFloat(el.getAttribute('data-fit'));
      if (!max) continue;
      try {
        var len = el.getComputedTextLength();
        /* a DETACHED or display:none host measures every run as 0 — skipping
           keeps a hidden mount from silently "passing" the readability floor
           (and from silently skipping the shrink, which is how GEM MINT once
           sailed past its panel in a test harness) */
        if (!len) continue;
        if (len > max) {
          var size = parseFloat(el.getAttribute('font-size')) * (max / len) * 0.98;
          el.setAttribute('font-size', r2(size));
        }
        floor = Math.min(floor, parseFloat(el.getAttribute('font-size')));
      } catch (_) {}
    }
    return floor === 99 ? null : floor;
  }

  /* ── PREVIEW FOIL, PRINT WHITE ────────────────────────────────────────
     The stock is silver holographic foil and there is no white ink, so every
     transparent area of the SVG means "bare foil". Two consumers, two grounds:
       · previews (builder, cart, landing) sit the SVG on a foil-simulating
         gradient, or an Open Holo tag would render as ink floating on the
         page's dark background — invisible, and nothing like the product;
       · production (the Label Farm sidecar) passes {print:true} and renders on
         WHITE, because in the press pipeline white pixels = no ink laid =
         foil showing. The foil sim must NEVER reach a print render — it would
         be printed as grey ink across every tag. */
  var _cssDone = false;
  function ensureCss() {
    if (_cssDone) return;
    _cssDone = true;
    var s = document.createElement('style');
    s.textContent = '.gt-foil{background:linear-gradient(115deg,#c6cad6 0%,#e9ecf3 16%,' +
      '#b9c9dd 30%,#e8dfe8 44%,#c9d8cf 58%,#eef0f6 72%,#bfc6d4 86%,#e5e8f0 100%);' +
      'border-radius:8px;overflow:hidden}';
    document.head.appendChild(s);
  }

  /* ── PREVIEW FOIL SUBSTITUTION ─────────────────────────────────────────
     '#ffffff' is the bare-foil declaration. On the press that is the contract
     (white pixels = no ink = holographic stock showing); in a PREVIEW it
     rendered as flat white and hid the shine. So preview mounts swap every
     #ffffff fill/stroke — and the instance's white foil gradient — for one
     shared iridescent sweep. Print mounts are never touched. */
  var _FOIL_STOPS =
    '<stop offset="0" stop-color="#cdd4e2"/>' +
    '<stop offset="0.2" stop-color="#d3e9f6"/>' +
    '<stop offset="0.42" stop-color="#eedff0"/>' +
    '<stop offset="0.62" stop-color="#dcefe2"/>' +
    '<stop offset="0.8" stop-color="#e9e6f6"/>' +
    '<stop offset="1" stop-color="#ccd3e2"/>';
  function foilify(s) {
    var defs = s.querySelector('defs');
    if (!defs) return;
    var gid = 'gtpv' + (++_n);
    var g = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
    g.setAttribute('id', gid);
    g.setAttribute('gradientUnits', 'userSpaceOnUse');
    g.setAttribute('x1', '0'); g.setAttribute('y1', '0');
    g.setAttribute('x2', String(W)); g.setAttribute('y2', String(H));
    g.innerHTML = _FOIL_STOPS;
    defs.appendChild(g);
    var ref = 'url(#' + gid + ')';
    /* bake the foil ground INTO the svg — first paint inside the plate clip.
       Previews then look right with zero external CSS: dark plates keep their
       bare-foil ring, open grounds show the sim, and a stale stylesheet can
       never leave a tag floating transparent again. */
    var gclip = s.querySelector('g[clip-path]');
    if (gclip) {
      var gnd = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      gnd.setAttribute('width', String(W));
      gnd.setAttribute('height', String(H));
      gnd.setAttribute('fill', ref);
      gclip.insertBefore(gnd, gclip.firstChild);
    }
    var els = s.querySelectorAll('[fill="#ffffff"], [stroke="#ffffff"]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('fill') === '#ffffff') els[i].setAttribute('fill', ref);
      if (els[i].getAttribute('stroke') === '#ffffff') els[i].setAttribute('stroke', ref);
    }
    /* the instance's own white 'f' gradient (panel edges, spine, logo backing)
       becomes the same sweep, so every foil element shines coherently */
    var f = s.querySelector('linearGradient[id$="f"]');
    if (f) f.innerHTML = _FOIL_STOPS;
    /* the security decal: preview at the weight the press will lay down */
    var dg = s.querySelector('g[data-gtdecal]');
    if (dg && !dg.getAttribute('opacity')) dg.setAttribute('opacity', '0.5');
  }

  function mount(host, cfg, opts) {
    opts = opts || {};
    host.innerHTML = svg(cfg);
    var s = host.querySelector('svg');
    if (s) { s.style.width = '100%'; s.style.height = 'auto'; s.style.display = 'block'; }
    if (opts.print) {
      host.classList.remove('gt-foil');
      host.style.background = '#ffffff';
    } else {
      ensureCss();
      host.classList.add('gt-foil');
      if (s) { try { foilify(s); } catch (_) {} }
    }
    return { svg: s, minText: s ? fit(s) : null };
  }

  window.GT = {
    W: W, H: H, LAYOUTS: LAYOUTS, BGS: BGS,
    norm: norm, svg: svg, mount: mount, fit: fit, metaLine: metaLine,
    /* the readability floor (mm) the builder blocks below — one number, one place */
    MIN_TEXT: 0.95
  };
})();
